export default {
	data() {
		return {
			moduleName: 'deviceTypes',
			entityName: 'device_type',
			detailPageRouteName: 'deviceTypeDetail',
			entity: {
				name: null,
				code: null,
				description: null,
				allow_extra_tracks: false,
				allow_extra_audio: false,
				allow_extra_subs: false,
				id_device_group: 0,
				supported_id_protocols: [],
				stream_profile_order: {},
				allowed_advertising_providers: []
			},
			updateFields: [
				'name',
				'code',
				'description',
				'allow_extra_tracks',
				'allow_extra_audio',
				'allow_extra_subs',
				'id_device_group',
				'supported_id_protocols',
				'stream_profile_order',
				'allowed_advertising_providers'
			],
		}
	},
	methods: {
		openRoute(routerName) {
			this.$router.push({
				name: routerName
			})
		},
		_beforeCreateEntityActions(params) {
			return this._clearParams(params);
		},
		_beforeUpdateEntityActions(params) {
			return this._clearParams(params);
		},
		_clearParams(params) {
			if (params.id_device_group === 0) {
				params.id_device_group = null;
			}

			return params;
		},
		filterFormParams(params) {
			let allowed = {}
			this._.forOwn(params, function (value, key) {
				if (this.updateFields.includes(key)) {
					allowed[key] = value
				}
			}.bind(this))
			return allowed
		},
		resetFields() {
			/*
			this.$refs['protocolformref'].validateProtocolFormRequiredFields()
			this.$refs['protocolformref'].$refs['nameref'].setTouched(false)
			this.$refs['protocolformref'].$refs['coderef'].setTouched(false) */
		},
		processErrorMessage(error) {
			let errorMessage = null;
			// this.$refs['protocolformref'].validateProtocolFormRequiredFields()

			this._.forEach(error['validation_errors'], function (message) {
				errorMessage = message;
			}.bind(this))

			return error['error_message'] = errorMessage || error['error_message'];
		},
		_processDetailErrorMessage(error) {
			let deleteError = null
			this._.forEach(error['validation_errors'], function (errorMessage) {
				deleteError = errorMessage;
			}.bind(this))

			if (deleteError) {
				error['error_message'] = deleteError
			}

			return error['error_message']
		},
		showDeviceTypeList() {
			this.$router.push({
				name: 'deviceTypes'
			});
		},
		getDependency() {
			this.setLoadingMessage();

			return this.entityService.getDependency().then((response) => {
				this.codecs = _.sortBy(response.codecs, [(x) => x.name.toLowerCase()]);
				this.deviceGroups = _.sortBy(response.device_groups, [(x) => x.name.toLowerCase()]);
				this.protocols = _.sortBy(response.protocols, [(x) => x.name.toLowerCase()]);
				this.streamProfiles = _.sortBy(response.stream_profiles, [(x) => x.name.toLowerCase()]);
				this.advertisingProviders = _.sortBy(response.advertising_providers, [(x) => x.name.toLowerCase()]);

				this.emptyMessage();
			});
		},
	}
}



// WEBPACK FOOTER //
// ./src/components/views/deviceTypes/mixins/deviceTypes.js